import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PoemContext } from './App';

function ShowResult() {
  let history = useHistory();
  const [poem, setPoem] = useContext(PoemContext);
  const [curPage, setcurPage] = useState(0);
  const sentsPerPage = 5;
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    "title": "",
    "author": "",
    "dynasty": ""
  });

  function openModal(index) {
    // console.log(poem);
    var source = poem.srcs[index];
    var cur_sent = poem.sents[index];
    var source_content = poem.src_content[index];
    // console.log(source);
    if (source.author.length === 0) {
      console.log("no source for this sentence");
    } else {
      // var title = source.substr(0, source.indexOf(' '));
      // var author = source.substr(source.indexOf(' ')+1);
      var title = source.title;
      var author = source.author;
      var dynasty = source.dynasty;
      setModalContent({
        "title": title,
        "author": author,
        "dynasty": dynasty,
        "cur_sent": cur_sent,
        "source_content": source_content
      });
      setShowModal(true);
    }
  };
  function closeModal() {
    setShowModal(false);
  };

  function backToHome() {
    setPoem({});
    history.replace('/');
  };

  function previousPage() {
    if (curPage > 0) {
      setcurPage(curPage-1);
    }
  };
  function nextPage() {
    if (curPage < poem.sents.length/sentsPerPage -1) {
      setcurPage(curPage+1);
    }
  };

  const footer = (
    <div>
      <div style={{'maxHeight': '15vh'}} className="fixed inset-x-0 bottom-0 text-center h-auto text-base md:text-lg bg-white p-2 md:p-5">
        <p>清华大学</p>
        <p>自然语言处理实验室</p>
        <p>九歌: <a href="http://jiuge.thunlp.org">jiuge.thunlp.org</a></p>
      </div>
      <img className="fixed bottom-1 md:bottom-2 left-1 w-20 h-20 md:w-20 md:h-20" src="../souqi/images/qrJiuge.png" alt='九歌二维码'/>
      <img className="fixed bottom-1 md:bottom-2 right-1 w-20 h-20 md:w-20 md:h-20" src="../souqi/images/qrTHUNLP.jpg" alt='THUNLP公众号二维码' />
    </div>
  );
  if (JSON.stringify(poem) === '{}') {
      history.replace('/');
      return(
        <div></div>
  )} 
  else {
    return (
      <div className="w-screen mx-auto h-screen bg-purple-100" style={{background: "url('../souqi/images/fengjing.png') no-repeat center center", backgroundSize: "cover"}}>
        <div className="w-full h-full bg-purple-200 bg-opacity-80">
        {showModal?
        <div className="absolute w-5/6 h-3/4 m-auto flex grid inset-0 rounded-3xl place-content-center bg-white z-10 bg-opacity-60">
          <div className="overflow-auto text-center text-purple-800 text-3xl" style={{width: '70vw'}}>
            {modalContent.title.length > 9 ? 
              <p className="text-xl">{modalContent.title}</p>:
              <p className="text-3xl">{modalContent.title}</p>
            }
            <br />
            <p className="text-2xl">{`[${modalContent.dynasty}] ${modalContent.author}`}</p>
            <br />
            {
              modalContent.source_content.map(
                function(item) {
                  // console.log(item);
                  // console.log(modalContent.cur_sent);
                  if (item === modalContent.cur_sent) {
                    return <p key={item} className="text-red-500">{item}</p>
                  } else {
                    return <p key={item}>{item}</p>
                  } 
                }
              )
            }
          </div>
          <br />
          <br />
          <button style={{width:'20vw'}} className="place-self-center bg-purple-500 text-white font-bold py-2 px-4 text-xl rounded-2xl focus:outline-none" onClick={closeModal}>
            返回
          </button>
        </div>:null}
        {showModal?null:
        <div style={{'height': '85vh'}} className="container m-auto flex grid gap-5 place-content-center">
          <p className="text-xl md:text-xl text-purple-800 place-self-center">{`"${poem.input}"的检索结果:`}</p>
          <div className="overflow-auto text-center text-purple-800 text-2xl md:text-2xl">
            {
              poem.sents.slice(curPage*sentsPerPage, (1+curPage)*sentsPerPage).map(
                function(item, index) {
                  return (
                    <p key={item}>
                      <span>{`${curPage*sentsPerPage+index+1}. ${item}`}</span> <br />
                      <span className="text-base md:text-base text-blue-600">{`相似度: ${Math.round(poem.score[curPage*sentsPerPage+index]*1000)/1000}`}</span>
                      &nbsp;&nbsp;
                      {poem.srcs[curPage*sentsPerPage+index].author.length === 0 ? 
                        <button className="w-max bg-red-400 text-white font-bold py-1 px-4 text-base md:text-base rounded-2xl rounded opacity-50 cursor-not-allowed">出处</button>:
                        <button className="w-max bg-red-400 text-white font-bold py-1 px-4 text-base md:text-base rounded-2xl focus:outline-none" onClick={openModal.bind(this, curPage*sentsPerPage+index)}>出处</button>
                      }
                    </p>
                  )}
              )
            }
          </div>
          
          <div>
          <div style={{"maxWidth": "90vw"}}>
          { curPage > 0 ?
          <button className="inline float-left place-self-center bg-purple-500 text-white font-bold p-2 text-base md:text-base rounded-2xl focus:outline-none" onClick={previousPage}>
            <img className="inline w-5 h-5 md:w-5 md:h-5" src="../souqi/images/pPage.png" alt=""/>
            <span className="inline">上一页</span>
          </button>:
          <button className="inline float-left place-self-center bg-purple-500 text-white font-bold p-2 text-base md:text-base rounded-2xl focus:outline-none opacity-50 cursor-not-allowed">
            <img className="inline w-5 h-5 md:w-5 md:h-5" src="../souqi/images/pPage.png" alt=""/>
            <span className="inline">已是首页</span>
          </button>
          }
          &nbsp;&nbsp;
          {/* <span className="mx-auto text-center text-purple-800 text-base md:text-xl">{`${curPage+1}/${Math.ceil(poem.sents.length/sentsPerPage)}`}</span> */}
          { curPage < Math.ceil(poem.sents.length/sentsPerPage) -1 ?
          <button className="inline float-right place-self-center bg-purple-500 text-white font-bold p-2 text-base md:text-base rounded-2xl focus:outline-none" onClick={nextPage}>
            <span className="inline">下一页</span>
            <img className="inline w-5 h-5 md:w-5 md:h-5" src="../souqi/images/nPage.png" alt=""/>
          </button>:
          <button className="inline float-right place-self-center bg-purple-500 text-white font-bold p-2 text-base md:text-base rounded-2xl focus:outline-none opacity-50 cursor-not-allowed">
            <span className="inline">已是尾页</span>
            <img className="inline w-5 h-5 md:w-5 md:h-5" src="../souqi/images/nPage.png" alt=""/>
          </button>
          }
          </div>
          <button className="w-full bg-purple-500 text-white font-bold p-1.5 mx-auto my-1 text-base md:text-base rounded-2xl focus:outline-none" onClick={backToHome}>
            另搜一句
          </button>
          </div>
          <div className="m-auto">
          <div className="flex m-auto">
            <div className="inline-block md:hidden float-left text-purple-800 text-lg md:text-lg text-center m-1">
              <p>您可长按</p>
            </div>
            <div className="hidden md:inline-block float-left text-purple-800 text-lg md:text-lg text-center m-1">
              <p>手机扫码</p>
            </div>
            &nbsp;&nbsp;
            <img className="inline float-right w-16 h-16 md:w-20 md:h-20" src="../souqi/images/souqiQR.png" alt="类义句搜奇二维码" />
            &nbsp;&nbsp;
            <div className="inline-block md:hidden float-right text-purple-800 text-lg md:text-lg text-center m-1">
              <p>扫码体验</p>
            </div>
            <div className="hidden md:inline-block float-right text-purple-800 text-lg md:text-lg text-center m-1">
              <p>随时体验</p>
            </div>
          </div>
          <div className="text-purple-800 text-lg md:text-lg text-center m-1">
            <p>©2021 THUNLP</p>
          </div>
          </div>
        </div>}
        </div>
        {showModal ? null : footer}
      </div>
    )
  }
};

export default ShowResult;